// extracted by mini-css-extract-plugin
module.exports = {"tabActiveHoldem":"_30adabf","tabActiveOmaha":"_99b84f9"};